var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tab"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7422 2.25H2.24219C1.41719 2.25 0.742188 2.925 0.742188 3.75V14.25C0.742188 15.075 1.41719 15.75 2.24219 15.75H15.7422C16.5672 15.75 17.2422 15.075 17.2422 14.25V3.75C17.2422 2.925 16.5672 2.25 15.7422 2.25ZM15.7422 14.25H2.24219V3.75H9.74219V6.75H15.7422V14.25Z",
    fill: "#EF6C00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletOrange);
export default __webpack_public_path__ + "static/media/tablet-orange.55826436ccb3eccc696bc823df0b89ea.svg";
export { ForwardRef as ReactComponent };